import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth.js'
import loading from './modules/loading.js'
import author from './modules/author.js'
import session from './modules/session.js'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
		auth,
		loading,
		author,
		session,
	}
})

export default store